export class ProcessInfoData {
    operatingPressure: string;
    operatingTemperature: string;
    testPressure: string;
    isDataValid: boolean;
}
